import { css } from "@emotion/react";

import { colors } from "../../../../styles";

export const listingsContainer = css`
  background-color: ${colors.white};
`;
